module.exports = __webpack_public_path__ + "img/img_financial-wellness.492f516a.png";